// extracted by mini-css-extract-plugin
export default {"loadingDots":"lazy_local_export_trigger-module___loadingDots___ed376a0d"};